import React from "react";
import Footer from "../../component/footer";
import Intro from "../../component/Intro";
import BlogSection from "../../component/post-comp/postcomp";

function Posts({ setmymode, mode }) {
  const textinline3 = {
    headh1: "Follow",
    spano: "Our blog post",
    subh1: "Posts up to new tecnology",
    paragraph1:
      "posts writen by experts of the field, kope up with recent web tecnologies , with evidence based knowladge",
  };
  return (
    <div>
      <Intro mode={mode} setmymode={setmymode} textinline={textinline3} />
      <BlogSection mode={mode} />
      <Footer />
    </div>
  );
}

export default Posts;
